import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How does the $1,000 guarantee work?',
      answer: 'If we don\'t deliver at least 30 qualified leads that turn into booked appointments within 60 days, we will write you a check for $1,000. No questions asked. We track every lead and appointment in our system, so there\'s complete transparency.'
    },
    {
      question: 'What makes DetailerX different from other marketing agencies?',
      answer: 'We specialize exclusively in auto detailing businesses. We know your industry, your customers, and what works. Plus, we\'re the only agency that guarantees results with real money - not just promises. We also handle everything from ads to booking, so you can focus on detailing.'
    },
    {
      question: 'How much does it cost?',
      answer: 'Our service starts at $1,997/month, which includes ad management, landing pages, CRM setup, and our guarantee. Your ad spend is separate and typically ranges from $1,500-$3,000/month depending on your market. Most clients see 3-5x ROI within the first 60 days.'
    },
    {
      question: 'Do I need to sign a long-term contract?',
      answer: 'No. We work month-to-month. You can cancel anytime. We\'re confident in our ability to deliver results, so we don\'t need to lock you into a long-term contract. If we\'re not delivering value, you\'re free to leave.'
    },
    {
      question: 'What if I\'m already running ads?',
      answer: 'That\'s great! We\'ll audit your current campaigns and show you where we can improve. Most detailers we work with were already running ads but weren\'t getting the results they wanted. We\'ll optimize everything and implement our proven system.'
    },
    {
      question: 'How quickly will I see results?',
      answer: 'Most clients start seeing qualified leads within the first 7-10 days of launching. By week 3-4, you should have a steady flow of appointments. Our goal is to get you to 30+ clients within 60 days, and we typically exceed that number.'
    }
  ];

  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl font-bold text-[#0A1628] mb-6">
            Common Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about our guarantee
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <span className="text-xl font-bold text-[#0A1628] pr-8">
                  {faq.question}
                </span>
                <i
                  className={`text-2xl text-[#0066FF] transition-transform ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>

              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed text-lg">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
